import { heroData } from '@/mocks/home';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative pt-[72px] min-h-[520px] md:min-h-[640px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20cinematic%20background%20with%20soft%20gradient%20warm%20tones%20from%20deep%20coral%20to%20amber%2C%20subtle%20film%20texture%20overlay%2C%20gentle%20light%20rays%2C%20minimal%20geometric%20shapes%2C%20luxurious%20theater%20atmosphere%2C%20dark%20edges%20vignette&width=1600&height=900&seq=hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 via-background-950/60 to-background-950/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500/20 text-accent-400 text-xs md:text-sm font-medium mb-4 md:mb-5 whitespace-nowrap">
              {heroData.tag}
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-background-50 leading-tight mb-3 md:mb-4">
              {heroData.h1}
            </h1>

            <p className="text-base md:text-lg text-background-50/80 font-medium mb-4 md:mb-5">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-background-50/65 leading-relaxed max-w-xl lg:max-w-none mb-6 md:mb-7">
              {heroData.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6 md:mb-7">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-extrabold text-accent-400">{stat.value}</div>
                  <div className="text-xs text-background-50/55 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => { e.preventDefault(); document.querySelector(heroData.primaryCta.href)?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-7 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg text-sm md:text-base hover:bg-primary-600 transition-all duration-200 text-center whitespace-nowrap"
              >
                {heroData.primaryCta.text}
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => { e.preventDefault(); document.querySelector(heroData.secondaryCta.href)?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto px-7 py-3 border border-background-50/25 text-background-50 font-medium rounded-lg text-sm md:text-base hover:bg-background-50/10 transition-all duration-200 text-center whitespace-nowrap"
              >
                {heroData.secondaryCta.text}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none flex-shrink-0">
            <div className="relative rounded-xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20home%20theater%20setup%20with%20large%20screen%20displaying%20cinematic%20content%2C%20warm%20ambient%20lighting%2C%20cozy%20atmosphere%2C%20premium%20entertainment%20experience%2C%20soft%20glow%20from%20screen%2C%20elegant%20interior&width=800&height=600&seq=hero-visual&orientation=landscape"
                alt="91视频网站 - 在线视频观看体验"
                className="w-full h-full object-cover"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/30 to-transparent"></div>
              <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2">
                <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </div>
                <div className="text-background-50 text-sm font-medium">在线观看中...</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}